import { Box, Stack, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { getFileFromUser } from '@weblite/file'
import { ReplaceButton } from '$common/buttons/replace-button'
import { validateMessageFileSizeAndShowError } from '$logic/message/helper'
import { messageTypeByFileType } from '$func/file'
import { changeFileTypeToValidFileOrAudioMessageType } from '../../../helper'

const StyledStack = styled(Stack)`
  overflow: hidden;
`
const StyledTitle = styled(Typography)`
  margin-right: 4px;
  font-size: 13px;
  line-height: 19.5px;
  font-weight: 700;
`

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  margin-left: auto;
  overflow: hidden;
`

interface Props {
  body: string
  canReplace?: boolean
  setSelectedFile: (file: File) => unknown
  messageType: 'FILE' | 'AUDIO'
}
export function EditFile({
  body,
  canReplace,
  setSelectedFile,
  messageType,
}: Props) {
  return (
    <StyledStack
      direction="row"
      justifyContent="space-between"
      sx={{ width: '100%' }}
    >
      <StyledBox>
        <StyledTitle color="primary" noWrap>
          {body}
        </StyledTitle>
      </StyledBox>

      {canReplace && (
        <ReplaceButton
          onClick={() =>
            getFileFromUser('file', (file: File | File[]) => {
              if (Array.isArray(file)) file = file[0]
              if (!file || !validateMessageFileSizeAndShowError(file)) return
              if (messageType === 'FILE')
                setSelectedFile(
                  changeFileTypeToValidFileOrAudioMessageType(file),
                )
              else if (messageTypeByFileType(file.type) === 'AUDIO')
                setSelectedFile(file)
            })
          }
        />
      )}
    </StyledStack>
  )
}
